import { render, staticRenderFns } from "./VProductForm.vue?vue&type=template&id=4eaf3a5b&"
import script from "./VProductForm.vue?vue&type=script&lang=js&"
export * from "./VProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports